module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "width": "100%",
      "max-height": "300px"
    }
  }, [_c('v-card-text', _vm._l((_vm.messages), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('p', {
      staticClass: "body-2 font-weight-bold"
    }, [_vm._v(_vm._s(_vm.viewAuthor(msg.author)))]), _vm._v(" "), _c('p', {
      staticClass: "body-1 font-weight-medium"
    }, [_vm._v(_vm._s(msg.text))]), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.getRelativeTime(msg.createdAt)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0)], 1), _vm._v(" "), (_vm.type === 'internal_notes' && _vm.isClient) ? _c('v-card-actions', [_c('v-textarea', {
    attrs: {
      "label": _vm.label,
      "rows": "2",
      "auto-grow": ""
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("\n      Save\n      "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type !== 'internal_notes') ? _c('v-card-actions', [_c('v-textarea', {
    attrs: {
      "label": _vm.label,
      "rows": "2",
      "auto-grow": ""
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("\n      Save\n      "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e682572"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/PostChatBox.vue
// module id = 2118
// module chunks = 0